import React from 'react';
import { Box, Typography } from '@mui/material';

import { v2Colors } from '../../design/theme';

const TRUST_ITEMS = [
  'Antibiotic-free',
  'Lab tested',
  '75-day raised',
  'Village raised',
];

export default function LandingTrustStrip() {
  return (
    <Box
      sx={{
        mx: { xs: -2, md: 0 },
        mb: 0,
        py: 1.25,
        px: 2,
        bgcolor: v2Colors.primaryDark,
        overflowX: 'auto',
        display: 'flex',
        alignItems: 'center',
        gap: 2.25,
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
    >
      {TRUST_ITEMS.map((label) => (
        <Typography
          key={label}
          component="span"
          sx={{
            color: v2Colors.canvas,
            fontSize: '0.7rem',
            fontWeight: 600,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.75,
            '&::before': {
              content: '""',
              width: 4,
              height: 4,
              borderRadius: '50%',
              bgcolor: v2Colors.canvas,
              opacity: 0.75,
              flexShrink: 0,
            },
          }}
        >
          {label}
        </Typography>
      ))}
    </Box>
  );
}
